import React, { useMemo } from 'react'
import { Box, BoxProps, Divider, Grid, Hidden } from '@material-ui/core'
import { footerItems } from 'constants/Anchors'
import { useGetOrganization } from 'hooks/useGetOrganization'
import CopyrightText from '../CopyrightText'
import Logo from '../Logo'
import NavigationLinks from '../NavigationLinks'
import SocialIcons from '../SocialIcons'
import { useStyles } from './styles'
import { SocialIconProps } from '../SocialIcon/SocialIcon'

const Footer: React.FC<BoxProps> = ({ className, ...props }) => {
  const classes = useStyles()
  const { organization, subDomain } = useGetOrganization()

  const settingsKey = subDomain?.includes('test') ? 'draftSettings' : 'publishedSettings'
  const iconColor = useMemo(
    () =>
      organization?.whiteLabel
        ? organization?.[settingsKey]?.Typography?.ThemeCustomization?.SelectedMode === 'DarkMode'
          ? '#fff'
          : '#000'
        : '#fff',
    [organization, settingsKey]
  )
  // @ts-ignore
  const socialIconsList: SocialIconProps[] = organization?.whiteLabel
    ? organization?.[settingsKey]?.ContactApplication?.Socials
      ? Object.entries(organization?.[settingsKey]?.ContactApplication?.Socials)
          .map(([key, value]) =>
            value
              ? {
                  icon: key,
                  url: value as string,
                }
              : null
          )
          .filter(Boolean)
      : []
    : []

  return (
    <Box id='footer' mt={16} component='footer' className={`${classes.footerBox} ${className || ''}`} {...props}>
      {/* Mobile and tablet view */}
      <Hidden mdUp>
        <Grid container alignItems='flex-start' className={classes.footerContainer}>
          <Grid item md={4}>
            <NavigationLinks display='flex' flexDirection='column' items={footerItems} />
          </Grid>
          <Divider className={classes.divider} />
          <Grid item xs={12} md={8}>
            <CopyrightText m={3} />
            <SocialIcons items={socialIconsList} m={3} iconColor={iconColor} />
          </Grid>
        </Grid>
      </Hidden>

      {/* Desktop view */}
      <Hidden smDown>
        <Grid container alignItems='center' className={classes.footerContainer}>
          <Grid item xs={12} md={3} lg={4}>
            <Logo withText m={3} />
            <CopyrightText m={3} />
            <SocialIcons items={socialIconsList} m={3} iconColor={iconColor} />
          </Grid>
          <Grid item xs={12} md={6} lg={5}>
            <NavigationLinks items={footerItems} />
          </Grid>
        </Grid>
      </Hidden>
    </Box>
  )
}

export default Footer
